import { TYPE_INSTANCE1, TYPE_INSTANCE2, TYPE_INSTANCE4, TYPE_INSTANCE_MASTER_EMR } from "App/constants";
import { fetchData, fetchDataPost, isNull } from "App/utils/helpers";
import { LIST_URL_REGISTRASI } from "utils/registrations";

export const MasterActions = {
  GET_JENIS_LAYANAN: "GET_JENIS_LAYANAN",
  GET_ALL_JENIS_LAYANAN: "GET_ALL_JENIS_LAYANAN",
  GET_ASURANSI: "GET_ASURANSI",
  GET_PERUSAHAAN: "GET_PERUSAHAAN",
  GET_DOKTER: "GET_DOKTER",
  GET_POLIKLINIK: "GET_POLIKLINIK",
  GET_SPESIALIS: "GET_SPESIALIS",
  GET_KELAS_KUNJUNGAN: "GET_KELAS_KUNJUNGAN",
  GET_KELAS_KAMAR: "GET_KELAS_KAMAR",
  GET_GUDANG_PENJUALAN: "GET_GUDANG_PENJUALAN",
  GET_RUANG: "GET_RUANG",
  GET_ACCESS_FA: "GET_ACCESS_FA",
  GET_SETTING_RS: "GET_SETTING_RS",
};

export const MasterInitialState = {
  jenis_layanan: {
    list_all: [],
    list_select: [],
    list_all_type: [],
  },

  all_jenis_layanan: {
    list_select: [],
  },

  spesialis: {
    list_all: [],
    list_select: [],
    list_select_code: [],
  },

  asuransi: {
    list_all: [],
    list_select: [],
  },

  perusahaan: {
    list_all: [],
    list_select: [],
  },

  poliklinik: {
    list_all: [],
    list_select: [],
    list_select_code: [],
  },

  kelas_kunjungan: {
    list_select: [],
  },

  kelas_kamar: {
    list_select: [],
  },

  ruang: {
    list_select: [],
  },

  dokter: {
    list_all: [],
    list_select: [],
    list_select_spec: [],
    list_select_name: [],
  },

  gudangPenjualan: {
    list_all: [],
    list_select: [],
    list_select_multipel: [],
  },

  access_fa:{
    access: false
  },

  setting:{
    favicon:"",
    name:""
  }
};

export const getJenisLayanan = () => {
  return (dispatch) => {
    fetchData(
      TYPE_INSTANCE2,
      LIST_URL_REGISTRASI.kunjungan_rawat_jalan.jenis_layanan
    ).then((response) => {
      const _temp = [];
      response.map((item) => {
        return _temp.push({
          value: item.id,
          label: item.name,
        });
      });
      dispatch({
        type: MasterActions.GET_JENIS_LAYANAN,
        payload: {
          list_all: response.body,
          list_select: _temp,
        },
      });
    });

    fetchData(TYPE_INSTANCE2, "jenis_layanan/listjenis_layanan").then(
      (response) => {
        const _temp = [];
        response.map((item) => {
          return _temp.push({
            value: item.id,
            label: item.name,
          });
        });
        dispatch({
          type: MasterActions.GET_ALL_JENIS_LAYANAN,
          payload: {
            list_select: _temp,
          },
        });
      }
    );
  };
};

export const getKelasKunjungan = () => {
  return (dispatch) => {
    fetchData(
      TYPE_INSTANCE2,
      LIST_URL_REGISTRASI.kunjungan_rawat_inap.kelas_kunjungan
    ).then((response) => {
      const _temp = [];
      response.map((item) => {
        return _temp.push({
          value: item.id,
          label: item.name,
        });
      });
      dispatch({
        type: MasterActions.GET_KELAS_KUNJUNGAN,
        payload: {
          list_all: response.body,
          list_select: _temp,
        },
      });
    });
  };
};

export const getKelasKamar = () => {
  return (dispatch) => {
    fetchData(
      TYPE_INSTANCE2,
      LIST_URL_REGISTRASI.kunjungan_rawat_inap.kelas_kamar
    ).then((response) => {
      const _temp = [];
      response.map((item) => {
        return _temp.push({
          value: item.id,
          label: item.name,
        });
      });
      dispatch({
        type: MasterActions.GET_KELAS_KAMAR,
        payload: {
          list_all: response.body,
          list_select: _temp,
        },
      });
    });
  };
};

export const getRuang = () => {
  return (dispatch) => {
    fetchData(TYPE_INSTANCE2, "/bed/listruang").then((response) => {
      const _temp = [];
      response.map((item) => {
        return _temp.push({
          value: item.id,
          label: item.name,
        });
      });
      dispatch({
        type: MasterActions.GET_RUANG,
        payload: {
          list_all: response.body,
          list_select: _temp,
        },
      });
    });
  };
};

export const getAsuransi = () => {
  return (dispatch) => {
    fetchData(
      TYPE_INSTANCE2,
      LIST_URL_REGISTRASI.kunjungan_rawat_jalan.asuransi
    ).then((response) => {
      const _temp = [];
      response.map((item) => {
        return _temp.push({
          value: item.id,
          label: item.name,
        });
      });
      dispatch({
        type: MasterActions.GET_ASURANSI,
        payload: {
          list_all: response.body,
          list_select: _temp,
        },
      });
    });
  };
};

export const getSpesialis = () => {
  return (dispatch) => {
    fetchData(
      TYPE_INSTANCE1,
      LIST_URL_REGISTRASI.kunjungan_rawat_inap.spesialis
    ).then((response) => {
      const _temp = [];
      const _tempCode = [];

      response.map((item) => {
        _tempCode.push({
          value: item.code,
          label: item.name,
        });
        return _temp.push({
          value: item.id,
          label: item.name,
          code: item.code,
        });
      });
      dispatch({
        type: MasterActions.GET_SPESIALIS,
        payload: {
          list_all: response,
          list_select: _temp,
          list_select_code: _tempCode,
        },
      });
    });
  };
};

export const getPerusahaan = () => {
  return (dispatch) => {
    fetchData(
      TYPE_INSTANCE2,
      LIST_URL_REGISTRASI.kunjungan_rawat_jalan.perusahaan
    ).then((response) => {
      const _temp = [];
      response.map((item) => {
        return _temp.push({
          value: item.id,
          label: item.name,
        });
      });
      dispatch({
        type: MasterActions.GET_PERUSAHAAN,
        payload: {
          list_all: response.body,
          list_select: _temp,
        },
      });
    });
  };
};

export const getPoliklinik = () => {
  return (dispatch) => {
    fetchData(
      TYPE_INSTANCE1,
      LIST_URL_REGISTRASI.kunjungan_rawat_jalan.poliklinik
    ).then((response) => {
      const _temp = [];
      const _tempKode = [];
      response.map((item) => {
        _tempKode.push({
          value: item.code,
          label: item.name,
        });
        return _temp.push({
          value: item.id,
          label: item.name,
        });
      });
      dispatch({
        type: MasterActions.GET_POLIKLINIK,
        payload: {
          list_all: response.body,
          list_select: _temp,
          list_select_code: _tempKode,
        },
      });
    });
  };
};

export const getDokter = () => {
  return (dispatch) => {
    fetchData(
      TYPE_INSTANCE1,
      LIST_URL_REGISTRASI.kunjungan_rawat_jalan.dokter
    ).then((response) => {
      const _temp = [];
      const _tempSelect = [];
      const _tempSelectName = [];

      response.map((item) => {
        _tempSelect.push({
          value: `${item.id}--${item.spec_code}`,
          label: `${item.fullname}`,
        });

        _tempSelectName.push({
          value: `${item.fullname}`,
          label: `${item.fullname}`,
        });

        return _temp.push({
          value: item.id,
          label: item.fullname,
          spec_code: item.spec_code,
          spesialis_id: item.spesialist_id,
          spesialis_name: item.spesialis_name,
          kode_bridge: item.kode_bridge,
        });
      });
      dispatch({
        type: MasterActions.GET_DOKTER,
        payload: {
          list_all: response,
          list_select: _temp,
          list_select_spec: _tempSelect,
          list_select_name: _tempSelectName,
        },
      });
    });
  };
};

export const getGudangPenjualan = () => {
  return (dispatch) => {
    fetchData(TYPE_INSTANCE4, "/wmsfarmasi/gudang/list-penjualan", "data").then(
      (response) => {
        const _temp = [];
        const _temp_select = [];
        response.map((item) => {
          _temp.push({
            id_gudang: item.gudangId,
            nama_gudang: item.name,
          });

          return _temp_select.push({
            value: item.gudangId,
            label: item.name,
          });
        });
        dispatch({
          type: MasterActions.GET_GUDANG_PENJUALAN,
          payload: {
            list_all: response.body,
            list_select: _temp_select,
            list_select_multipel: _temp,
          },
        });
      }
    );
  };
};

export const getAccessFA = () => {
    return (dispatch) => {
        fetchDataPost(TYPE_INSTANCE4, "/wmsassets/transaksi/fixasset/management_acces", "result").then((response) => {
        dispatch({
          type: MasterActions.GET_ACCESS_FA,
          payload: {
            access: isNull(response) ? false : response,
          },
        });
      });
    };
  };

  export const getSettingRS = () => {
    return (dispatch) => {
      fetchData(TYPE_INSTANCE_MASTER_EMR, "/resource/get-data-rs", "data").then((response) => {
        dispatch({
          type: MasterActions.GET_SETTING_RS,
          payload: isNull(response) ? {
            favicon:'',
            name:''
          } : response,
        });
      });
    };
  };